module.exports = __webpack_public_path__ + "img/Sheep.e54311c1.jpg";